import { useContext } from 'react';
import { AppContext } from './Context';

// Custom hook to use the context values in components
export function useSettingsContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error(
      'useSettingsContext must be used within an AppContextProvider'
    );
  }

  return context;
}
